module.exports = __webpack_public_path__ + "img/end-formation.745b86d0.png";